import { common } from "./common.service"

export const templateDataService = {
    get,
}

function get({id, language='it'}) {
    const url = `templateinfo/${id}/${language}`;
    return common.fetchAPI({ url, method: "GET", useDigitalPixAPI: true });
}